var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.partNumber && _vm.partNumber.length > 0)?_c('span',[_c('span',{staticClass:"grey--text"},[_vm._v(" Part # ")]),_c('span',[_c('b',[_vm._v(_vm._s(_vm.partNumber))])]),_c('br')]):_vm._e(),_c('span',{},[_vm._v(" "+_vm._s(_vm.partDescription)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }